var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-xl-1200-.container-lg",
    transform: "translate(-46, -4284)",
    fill: "#85827F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5,4284 L47.4953129,4284 C46.6703126,4284 46,4284.67969 46,4285.51406 L46,4303.48594 C46,4304.32031 46.6703126,4305 47.4953129,4305 L65.5,4305 C66.325001,4305 67,4304.32031 67,4303.48594 L67,4285.51406 C67,4284.67969 66.325001,4284 65.5,4284 Z M52.3468754,4302 L49.2343757,4302 L49.2343757,4291.97812 L52.3515632,4291.97812 L52.3515632,4302 L52.3468754,4302 Z M50.7906256,4290.60938 C49.7921879,4290.60938 48.9859381,4289.79844 48.9859381,4288.80469 C48.9859381,4287.81094 49.7921886,4287 50.7906263,4287 C51.7843761,4287 52.5953138,4287.81094 52.5953138,4288.80469 C52.5953138,4289.80312 51.7890639,4290.60938 50.7906263,4290.60938 L50.7906256,4290.60938 Z M64.0140626,4302 L60.9015629,4302 L60.9015629,4297.125 C60.9015629,4295.9625 60.8781254,4294.46719 59.2843754,4294.46719 C57.6625001,4294.46719 57.4140632,4295.73281 57.4140632,4297.04063 L57.4140632,4302 L54.3015635,4302 L54.3015635,4291.97812 L57.2875009,4291.97812 L57.2875009,4293.34687 L57.3296881,4293.34687 C57.7468753,4292.55937 58.7640626,4291.72969 60.278126,4291.72969 C63.4281251,4291.72969 64.0140626,4293.80625 64.0140626,4296.50625 L64.0140626,4302 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogoGrey);
export default __webpack_public_path__ + "static/media/LinkedInLogoGrey.f640968b176c5736e077ea0aff758eee.svg";
export { ForwardRef as ReactComponent };